import { useNavigate } from 'react-router-dom';
import { ReactNode } from 'react';
import successImgUrl from '@/assets/images/session-success-image.svg';
import {
	CircleChevronDown,
	ClipboardPlus,
	Lightbulb,
	Mail,
	Pen,
} from 'lucide-react';
import { StepButtonContainer } from '@/components';
import { getUserData } from '@/utils/cookies';

const StepSuccess = () => {
	const navigate = useNavigate();
	const iconClass = 'w-4 h-4 text-dark';

	const feedbackTextMap: Record<string, ReactNode> = {
		'Tudo pronto para sua consulta!': (
			<CircleChevronDown className={iconClass} />
		),
		'O Link para a consulta foi enviado para o seu Email': (
			<Mail className={iconClass} />
		),
		'Você poderá acessar a consulta na página inicial': (
			<Lightbulb className={iconClass} />
		),
		'Se necessário, você pode editar ela!': <Pen className={iconClass} />,
	};

	interface FeedBackItemProps {
		icon: ReactNode;
		text: string;
	}

	const FeedBackItem = ({ icon, text }: FeedBackItemProps) => {
		return (
			<div className="flex items-center gap-2 py-1">
				{icon}
				<span className="text-sm font-medium text-dark">{text}</span>
			</div>
		);
	};

	const userData = getUserData();

	const handleNext = () => {
		if (userData) {
			navigate('/home');
			return;
		}
		navigate('/admin/consultas');
	};

	return (
		<section className="flex !h-full w-full flex-col justify-between space-y-8">
			<div className="m-auto flex w-full max-w-3xl flex-col gap-8 md:flex-row">
				<div className="flex justify-center">
					<img
						src={successImgUrl}
						alt="Success illustration"
						className="max-w-xs"
					/>
				</div>

				<div className="flex flex-col gap-4">
					<div className="flex w-full items-center justify-center gap-2 rounded-md bg-slate-600 px-3 py-2 text-white md:w-fit">
						<ClipboardPlus className="w-5" />
						<span className="font-medium">
							Aguardando pagamento
						</span>
					</div>

					<div className="flex flex-col gap-2">
						{Object.entries(feedbackTextMap).map(([text, icon]) => (
							<FeedBackItem key={text} text={text} icon={icon} />
						))}
					</div>
				</div>
			</div>

			<StepButtonContainer
				onHandleNext={handleNext}
				nextStepText="Voltar a página inicial"
			/>
		</section>
	);
};

export { StepSuccess };
